<div *ngIf="!addWebinar && !updateWebinar && !viewWebinar" class="webinars-container">

  <div class="webinar-parent">
    <div class="d-flex justify-content-between align-items-center mt-0 exhibitions-table">
      <div class="pb-4">
        <h2 class="page-heading">Webinars</h2>
      </div>

      <div class="d-flex webinar-management-header m-2 ">
        <mat-form-field appearance="outline" class="m-2 mr-1 search-bar">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput placeholder="Search" [(ngModel)]="searchKeyword" (input)="searchWebinar($event)">
          <button *ngIf="searchKeyword?.trim()" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
            <mat-icon class="oem-search-clear">close</mat-icon>
          </button>
        </mat-form-field>
        <button class="header-btn m-2 mr-1 export-btn" mat-raised-button (click)="exportOEMData()">
          <img src="assets/images/icons/Export.svg" alt=""> Export
        </button>
        <button class="header-btn m-2 mr-1 filter-btn" mat-raised-button (click)="openFilter()">
          <img src="assets/images/filter.svg" alt=""> Filter
        </button>
        <button class="header-btn m-2 add-webinar-btn" mat-raised-button (click)="add()">
          <img src="assets/images/icons/vector.svg" alt="" style="fill: white;"> Add Webinar
        </button>
      </div>
    </div>
    <div class="row mt-3 mb-3" *ngIf="isFiltered">
      <div class="col-12">
        <div class="d-flex align-items-center">
          <h2 class="me-2 mb-0 filters_applied">Applied Filters:</h2>
          <div class="chip-container d-flex flex-wrap">          
            <mat-chip-list>
              <mat-chip
                *ngFor="let chip of chips"
                color="primary"
                selected
                removable
                (removed)="remove(chip)"
              >
                {{ chip.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
            <button class=" mwe-button--primary mwe-button " (click)="clearAllFilters()">Clear All</button>
          </div>
        </div>
      </div>
    </div>
    <div class="summary-container">
      <div *ngFor="let object of objects" class="block">
        <div class="inside-block">
          <img [src]="object.image" alt=""class=" webinar-icon">
          <div class="detailed-summary">
            <h2 class="summary-text">{{ object.name }}</h2>
            <h1 class="summary-count">{{ object.count }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="webinar-child">
    <app-mwe-table [columns]="columns" [dynamicPageSize]="pageSize" [exportTitle]="'Webinars'"
      [totalEntries]="totalEntries" [isDynemicPagination]="true" [showPagination]="showPagination" [data]="data"
      [showHeader]="true" (selectedAction)="selectedAction($event)" [currentPageChanged]="pageIndex"
      (pageChanged)="onPageChanged($event)" (searchTerm)="onSearch($event)"
      [initialSearchValue]="searchKeyword"></app-mwe-table>
  </div>
</div>

<div *ngIf="addWebinar">
  <app-add-webinar [addWebinar]="addWebinar" (backEvent)="close($event)"
    (selectedAction)="selectedAction($event)"></app-add-webinar>
</div>

<div *ngIf="updateWebinar">
  <app-add-webinar [updateWebinar]="updateWebinar" (backEvent)="close($event)" [updateWebinarID]="updateWebinarID"
    (selectedAction)="selectedAction($event)"></app-add-webinar>
</div>

<div *ngIf="viewWebinar">
  <app-view-webinar [viewWebinar]='viewWebinar' [viewWebinarID]="viewWebinarID" (backEvent)="close($event)"
    (selectedAction)="selectedAction($event)"></app-view-webinar>
</div>